import { create } from "zustand";
import { notificationApiService } from "../../infrastructure/api/notification-api-service";

/**
 * 읽지 않은 알림 수. 헤더 알림 아이콘의 도트와 알림함 페이지가 같은 값을 본다.
 * 알림함에서 읽음 처리하면 여기 값을 바로 줄여 도트가 다음 폴링을 기다리지 않고 꺼진다.
 */
interface NotificationState {
  unreadCount: number;
  refreshUnreadCount: () => Promise<void>;
  setUnreadCount: (count: number) => void;
  decreaseUnreadCount: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  unreadCount: 0,
  refreshUnreadCount: async () => {
    try {
      set({ unreadCount: await notificationApiService.getUnreadCount() });
    } catch {
      // 일시적인 실패로 도트를 지우지 않는다. 다음 폴링에서 다시 맞춘다.
    }
  },
  setUnreadCount: (count) => set({ unreadCount: Math.max(0, count) }),
  decreaseUnreadCount: () => set((state) => ({ unreadCount: Math.max(0, state.unreadCount - 1) })),
}));
